import { Grid } from '@mui/material';
import { FC, MouseEventHandler } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';

import { APP_URLS } from 'src/constants';
import { Typography } from 'src/components';
import serviceExports from 'src/configuration/serviceExports';
import { useType } from 'src/contexts';

interface MainLayoutProps {
  isAdmin: boolean;
}

const MainLayout: FC<MainLayoutProps> = ({ isAdmin }) => {
  const navigate = useNavigate();

  const location = useLocation();
  const state = location.state as any;
  const {type} = useType();

  const {setType} = useType();

  const handleClickLogOut: MouseEventHandler = async (event) => {
    event.preventDefault();
    //await onSignOut();
    navigate(APP_URLS.ROOT);
  };

  return (
    <>
      <nav
        aria-label="Horizontal School Form Navigation"
        className="cb-menu-list cb-menu-list-horizontal position-sticky cb-border-bottom cb-box-shadow-bottom cb-white-bg display-flex justify-content-xs-between align-items-xs-center"
        style={{ height: 56, paddingLeft: 16, top: 0, zIndex: 100 }}>
        {type === 'ai' && <Typography variant="h3" style={{ fontWeight: 'bold' }}>School Code Request Form</Typography>}
        {type === 'di' && <Typography variant="h3" style={{ fontWeight: 'bold' }}>Score Send Code Request Form</Typography>}
        <ul>
          <li>
            {type === 'ai' && <Link className="cb-menu-link" to={APP_URLS.HOME} state={{ type}}> Home </Link>}
            {type === 'di' && <Link className="cb-menu-link" to={APP_URLS.DIHOME} state={{ type }}> Home </Link>}
          </li>
          <li>
            <Link className="cb-menu-link" 
            to={APP_URLS.LANDING} 
            state={{type:''}} 
            onClick = { ()=> {
             setType('');
             sessionStorage.removeItem('currentType');
             }}> Landing </Link>
          </li>
        </ul>
      </nav>
      <Grid container justifyContent="center" sx={{ p: 3 }}>
        {isAdmin ? (
          <Grid item xl={12} lg={12} xs={12}>
            <Outlet />
          </Grid>
        ) : (
          <Grid item xl={10} lg={12} xs={12}>
            <Outlet />
          </Grid>
        )}
      </Grid>
    </>
  );
};

export default MainLayout;
